import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { imageUrl } from "../../const/constants";
import { getOurBooks } from "./_request";

const OurBooksHighlight = () => {
  const navigate = useNavigate();
  const [books, setBooks] = useState([]);
  const [loading, setLoading] = useState(true);
  const BOOK_URL = `${imageUrl}/matbuaatImages`;

  const fetchBooks = async () => {
    setLoading(true);
    try {
      const response = await getOurBooks();
      if (response.Result) {
        setBooks(response.Books.slice(0, 3)); // Take first 3 books
        setLoading(false);
      }
    } catch (error) {
      // Handle error if needed
      setBooks([]);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBooks();
  }, []);

  const handleBookClick = (bookId) => {
    navigate(`/tableeghat/mutabaat/${bookId}`);
  };

  const handleSeeMoreBooks = () => {
    navigate("/tableeghat/ourBooks");
  };

  return (
    <div className="mt-10 justify-center transition-all duration-300">
      <h1 className="text-2xl lg:text-4xl font-nastaleeqKasheeda">
        امن کی مطبوعات
      </h1>
      <div className="flex flex-col items-center justify-center">
        {/* Books Flex Container */}
        {loading ? (
          <div className="flex justify-center items-center h-24 mt-12">
            <div className="animate-spin rounded-full h-10 w-10 border-t-4 border-primary border-solid"></div>
          </div>
        ) : books.length > 0 ? (
          <div className="flex flex-wrap justify-center gap-10 md:gap-10 lg:gap-16 mt-12 px-5 md:px-10 lg:px-20">
            {books.map((book, index) => (
              <div
                key={index}
                className="flex flex-col items-center w-44 md:w-52 transition-all duration-300 hover:scale-110 cursor-pointer"
                onClick={() => handleBookClick(book.id)}
              >
                {/* Book Image */}
                <img
                  src={`${BOOK_URL}/${book.image}`}
                  alt={book.bookName}
                  className="w-full h-auto rounded-lg transition-all duration-300 hover:shadow-xl"
                  loading="lazy"
                />
                {/* Book Name */}
                <p className="mt-4 text-xl md:text-xl lg:text-2xl font-nastaleeqKasheeda text-black transition-colors duration-300 hover:text-primary">
                  {book.bookName}
                </p>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center text-gray-500 py-8 mt-12">
            کوئی کتابیں دستیاب نہیں
          </div>
        )}
      </div>
      <button
        onClick={handleSeeMoreBooks}
        className="mt-5 lg:mt-5 md:mt-8 mb-10 text-xl md:text-xl lg:text-2xl text-primary underline transition-all duration-300 hover:text-primary/80 hover:scale-105"
      >
        مزید کتب دیکھیں
      </button>
    </div>
  );
};

export default OurBooksHighlight;
